module.exports = __webpack_public_path__ + "img/Manufacturer.757024a1.svg";